var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFather(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 28",
    style: {
      enableBackground: "new 0 0 15 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#424242;}\n\t.st1{fill:none;stroke:#C9EDD7;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3,16.6C1.2,16.6,1.3,16.6,1.3,16.6L1.3,16.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,13.6L12,5.3c-0.1-0.6-0.6-1-1.2-1H9.5C8.9,5.4,7.7,6.1,6.4,6.1S3.9,5.4,3.3,4.3H2c-0.6,0-1.2,0.5-1.2,1.1 l-0.7,9.8c0,0.7,0.5,1.3,1.2,1.3c0.6,0,1.2-0.5,1.3-1.1L3,8.8l0,17.2c0,0.8,0.6,1.5,1.4,1.5c0.8,0,1.5-0.6,1.5-1.5v-9.2 c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v9.1c0,0.8,0.6,1.5,1.4,1.5c0.8,0,1.5-0.6,1.5-1.5l0-18.2l1.3,6.3 c-0.4,0.4-0.7,1-0.7,1.6v10.9c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V16.3c0.2,0.2,0.5,0.3,0.7,0.3c0.1,0,0.1,0,0.2,0 c0.3,0,0.5-0.2,0.6-0.3v0.4c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1C14.9,14.8,14.3,14,13.5,13.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,16.8c-0.1-1.1,0.2-1.7,0.7-1.7s0.8,0.5,0.7,1.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,0C7.9,0,9,1.2,9,2.6S7.9,5.3,6.4,5.3S3.8,4.1,3.8,2.6S4.9,0,6.4,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFather);
export default __webpack_public_path__ + "static/media/father.f90e5823ab4e6b4d65b6bf6225b82db7.svg";
export { ForwardRef as ReactComponent };